export const ru = {
    contact_me: 'У меня есть вопросы, свяжитесь, пожалуйста, со мной',
};
